export default "__VITE_ASSET__JNxtU6hr__"